/** @jsxImportSource @emotion/react */

import { Dispatch, FC, SetStateAction } from 'react'
import { findAllStudyNoteGroup_findAllStudyNoteGroup_items as IGroup } from '__generatedTypes__/findAllStudyNoteGroup'
import { SubjectExtendedFull } from 'hooks/usePlatformsAndSubjects'
import StudyNoteGroups from './StudyNoteGroups'
import StudyNoteTabs from './StudyNoteTabs'

interface IProps {
  selectedSubject: SubjectExtendedFull
  groups: IGroup[]
  setGroups: Dispatch<SetStateAction<IGroup[]>>
}

const StudyNoteContent: FC<IProps> = ({ selectedSubject, groups, setGroups }) => (
  <>
    <StudyNoteGroups groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    {groups.length > 0 && (
      <StudyNoteTabs groups={groups} selectedSubjectId={selectedSubject.id} initialSelected={groups[0]} />
    )}
  </>
)

export default StudyNoteContent
